import { JwtToken, LoginResponse, RefreshToken } from "@/api";

export class Store<T> {
  key: string;
  storage: Storage;

  constructor(key: string, storage: Storage = localStorage) {
    this.key = key;
    this.storage = storage;
  }

  set(value: T | null | undefined) {
    const json = JSON.stringify(value);
    this.storage.setItem(this.key, json);
  }

  get(): T | null {
    const json = this.storage.getItem(this.key);

    if (json === null) {
      return null;
    }

    return JSON.parse(json);
  }
}

const tokenStore = new Store<JwtToken>("ApiToken");
const userStore = new Store<LoginResponse>("CurrentUser");
const navigationStore = new Store<boolean>("NavigationSetting");
const calendarViewStore = new Store<number>("SelectedCalendarView");
const shownSlotsStore = new Store<number>("NumberOfShownSlots");
const showCancelledStore = new Store<boolean>("ShowCancelled");
const showUnsatisfiedStore = new Store<boolean>("ShowUnsatisfied");
const showShiftsStore = new Store<boolean>("ShowShifts");
const unplannedRidesSortByStore = new Store<number>("RidesSortBy");
const unplannedRidesOrderAscStore = new Store<boolean>("RidesOrderAsc");
const hideUnplannedStore = new Store<boolean>("HideUnplanned");
const boardDarkModeStore = new Store<boolean>("BoardDarkMode");
const refreshTokenStore = new Store<RefreshToken>("RefreshToken");

export interface OrdersFilterStore {
  customerId?: number;
  addressFrom: string;
  addressTo: string;
  date?: string;
  types: string[];
  states: string[];
}
const ordersFilterStore = new Store<OrdersFilterStore>("OrdersFilter");

export interface DaktelaDeviceSelection {
  extension: string;
  model: string;
}
const daktelaDeviceStore = new Store<DaktelaDeviceSelection>("DaktelaDevice");

export {
  tokenStore,
  userStore,
  navigationStore,
  calendarViewStore,
  shownSlotsStore,
  showCancelledStore,
  showShiftsStore,
  unplannedRidesSortByStore,
  unplannedRidesOrderAscStore,
  hideUnplannedStore,
  boardDarkModeStore,
  refreshTokenStore,
  showUnsatisfiedStore,
  ordersFilterStore,
  daktelaDeviceStore,
};
